import React from "react";
import { Play, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DominateYourAcreage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="dominate-your-acreage" className="dark bg-background text-foreground relative h-screen min-h-[800px] w-full overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569013/img/hero_poster_kubota.png" className="h-full w-full object-cover">
          <source src="/videos/land_clearing_hero.mp4" type="video/mp4" />
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569013/img/hero_poster_kubota.png" alt="Kubota SVL97-2 forestry mulcher clearing land" className="h-full w-full object-cover" />
        </video>
        {}
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {}
      <div className="relative z-10 container mx-auto h-full px-4 flex flex-col justify-center">
        <div ref={ref} className={`max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-black uppercase leading-[0.9] tracking-tight text-white mb-6 drop-shadow-xl">
            Dominate <br />
            <span className="relative inline-block">
              Your Acreage
              {}
              <span className="absolute -bottom-2 left-0 w-full h-2 md:h-4 bg-primary skew-x-[-12deg]" />
            </span>
          </h1>

          {}
          <p className="font-sans text-lg md:text-2xl text-gray-100 max-w-2xl mb-10 font-medium drop-shadow-md">
            Professional Land Clearing & Forestry Mulching in East Texas.
            Reclaim your property with precision and power.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-white text-lg px-8 py-6 h-auto font-bold uppercase tracking-wide shadow-lg hover:shadow-primary/20 transition-all">
              <Link to="/GetAQuotePage">
                Schedule Free Estimate
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="border-2 border-white text-white hover:bg-white hover:text-black bg-transparent text-lg px-8 py-6 h-auto font-bold uppercase tracking-wide backdrop-blur-sm transition-all">
              <Link to="/ActionFootagePage">
                <Play className="mr-2 size-5 fill-current" />
                Watch Equipment in Action
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 animate-bounce">
        <Link to="#about" className="group flex flex-col items-center gap-2 cursor-pointer">
          <span className="text-xs font-bold uppercase tracking-widest text-white/80 group-hover:text-primary transition-colors">
            Scroll
          </span>
          {}
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-white group-hover:text-primary transition-colors drop-shadow-lg">
            <path d="M12 22C12 22 5 10 5 5C5 3 7 2 12 2C17 2 19 3 19 5C19 10 12 22 12 22Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
            <path d="M12 22V6" stroke="rgba(0,0,0,0.3)" strokeWidth="1" strokeLinecap="round" />
          </svg>
        </Link>
      </div>
    </section>;
}